@if (!alreadyPayed) {
    <div class="ap-margin-bottom-6 ap-margin-top-6 ap-display-block">
        <h1>
            {{ 'landing-page.header-title' | apContent }}
        </h1>
    </div>
    @if (betaalverzoekFormControl) {
        <div class="ap-margin-bottom-2 ap-display-block">
            @if (betaalverzoek.bedrag) {
                <div class="ap-margin-bottom-2 ap-display-block">
                    <h2>{{ 'landing-page.details.title' | apContent }}</h2>
                    <payment-request-details [betaalverzoek]="betaalverzoek"> </payment-request-details>
                </div>
            }
            @if (!betaalverzoek.bedrag) {
                <div class="ap-margin-bottom-2 ap-display-block">
                    <open-amount [openAmountFormControl]="betaalverzoekFormControl" [betaalverzoek]="betaalverzoek"> </open-amount>
                </div>
            }
            <h2>{{ 'landing-page.details.betaalopties-title' | apContent }}</h2>
            <ap-button (onClick)="submitIdealPaymentTransaction()" [isDisabled]="isSubmitting" data-bb="submit" type="submit">
                <ap-submit-text
                    [isLoading]="isSubmitting"
                    [submitText]="submitButtonText"
                    [loadingText]="submitButtonLoadingText"
                ></ap-submit-text>
            </ap-button>
            <betaalverzoek-info class="ap-margin-top-4 ap-margin-bottom-2 ap-display-block"></betaalverzoek-info>
        </div>
    }
} @else {
    <div class="container_large">
        <section class="ap-justify-content-center ap-flex">
            <div class="ap-text-align-center">
                <ap-animation
                    class="ap-align-items-center"
                    data-bb="transaction-result-animation"
                    [name]="paymentRequestCompletedAnimation"
                    width="100px"
                    height="100px"
                >
                </ap-animation>
            </div>
        </section>
    </div>
    <div class="container_small" data-bb="summaryPageLarge">
        <section class="ap-justify-content-center ap-flex">
            <div class="ap-text-align-center ap-margin-bottom-4 ap-display-block">
                <div class="ap-text-align-center ap-margin-bottom-6 ap-display-block">
                    <h2>{{ 'landing-page.betaalverzoek-al-betaald-title' | apContent }}</h2>
                    <p>{{ 'landing-page.betaalverzoek-nog-eens-betalen-title' | apContent }}</p>
                </div>
                <ap-button (onClick)="payPaymentRequestAgain()" class="nba-button">{{
                    'landing-page.betaalverzoek-nog-eens-betalen.button' | apContent
                }}</ap-button>
            </div>
        </section>
    </div>
}
